import { priceFormatter } from '@2wunder/klarx-tool'
import { Space } from 'antd'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import React from 'react'

import { MemberProps } from '../../convention'

type Props = {
  attribute: keyof IRental
  bold?: boolean
  className?: string
}

const PriceInfo: React.FC<MemberProps<IRental, Props>> = ({
  member,
  props: { attribute, bold, className }
}) => {
  const { tAttribute } = ToolBox.useString()

  const title = tAttribute({ recordType: RecordType.rental, attribute })
  const value = priceFormatter(member[attribute] as number)

  return (
    <Space direction="horizontal" className="full-width justify-content-between">
      <span className={className}>{bold ? <strong>{title}</strong> : title}</span>
      <span className={className}>{bold ? <strong>{value}</strong> : value}</span>
    </Space>
  )
}

export default PriceInfo
